import React, {FC, useEffect} from 'react'
import {useFormContext, Controller} from 'react-hook-form'

type InputProps = {
  type?: string
  name: string
  textPlaceholder?: string
  maxLength?: number
  minLength?: number
  disabled?: boolean | undefined
}

const InputPassword2: FC<InputProps> = ({
  type = 'text',
  name,
  textPlaceholder,
  maxLength = 9999,
  minLength = 0,
  disabled = false,
  ...props
}) => {
  const {
    control,
    formState: {errors},
    setValue,
    watch,
  } = useFormContext()
  const value = watch(name) ?? ''

  useEffect(() => {
    if (value === undefined) {
      setValue(name, '')
    }
  }, [value, setValue, name])

  return (
    <div className='sdx_form_input position-relative w-100'>
      <Controller
        name={name}
        control={control}
        defaultValue={value}
        render={({field}) => (
          <input
            type='password'
            className='form-control sdx-centra-input-form'
            {...field}
            placeholder={textPlaceholder}
            maxLength={maxLength}
            minLength={minLength}
            disabled={disabled}
            // onChange={(e) => handleChange(e, field)}
          />
        )}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputPassword2
